export const PAGES_REQUIRED_FOR_SPLAT_MODEL = 20
export const DEFAULT_FOLDER_ID = -1
